import { styled } from "@mui/material"

export const Container = styled("div")`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  @media only screen and (max-width: 1320px) {
    flex-direction: column;
    gap: 10px;
  }
  @media only screen and (max-width: 480px) {
    align-items: initial;
  }
`

export const LeftSection = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
`
